export default class GetCategoriasByPerfilCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPerfilCurso) {
    try {
      const result = await this.#repository.getCategoriasByPerfilCurso(idPerfilCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
